import { createActionGroup, props } from '@ngrx/store';
import { AvailableLanguages } from '@core/components/header/lang-selection/lang-selection.config';

export const languageActions = createActionGroup({
  source: 'Language',
  events: {
    changeLanguage: props<{ lang: AvailableLanguages }>(),
    setVisibilityLang: props<{ visibilityLang: boolean }>(),
    updateWebLanguage: props<{ lang: AvailableLanguages }>(),
    setCommunicationLanguage: props<{ lang: AvailableLanguages }>(),
  },
});
